module.exports = __webpack_public_path__ + "img/pause-active.7340118c.svg";